import { TFunction } from "react-i18next";

import { OrderVipTreatmentMode } from "./enums";

const getOrderVipTreatmentOptions = (translate: TFunction<"translation", undefined>) => {
  const options = [
    { value: OrderVipTreatmentMode.NONE, label: translate("thereIsNoNeed") },
    { value: OrderVipTreatmentMode.VIP, label: translate("vipMode") },
    { value: OrderVipTreatmentMode.BLUEBARK, label: translate("bluebarkMove") },
    { value: OrderVipTreatmentMode.SAFETY, label: translate("satefyMove") },
  ];

  return options;
};

export { getOrderVipTreatmentOptions };
